import { JSX, ReactNode } from "react";

interface Props {
    children?: ReactNode;
    onClick?: () => void;
    type: "button" | "submit" | "reset";
    variant: "primary" | "secondary" | "tertiary" | "quaternary";
}

export const Button = (props: Props): JSX.Element => {
    const { children, onClick, type, variant } = props;

    return (
        <button
            type={type}
            onClick={onClick}
            className={`c-button c-button--${variant}`}
        >
            {children}
        </button>
    );
};
